import React from "react";
import { FontStyles } from "../../../utils/font-styles";
import { Button } from "../../../components/buttons/button";
import { CalloutBox } from "../../../components/base/callout-box";

interface ExistingSolicitorSelectedProps {
  solicitorName: string;
  onReset: () => void;
}

export const ExistingSolicitorSelected: React.FC<ExistingSolicitorSelectedProps> = ({ solicitorName, onReset }) => {
  return (
    <CalloutBox color="blue" style="outlined" className="flex-col md:flex-row md:justify-between md:items-center gap-3">
      <div className="flex flex-col gap-2">
        <span className={`${FontStyles["body-md"]} text-light-slate leading-none md:leading-none`}>
          Your selected solicitor:
        </span>
        <span className={`${FontStyles["body-xl"]} font-semibold text-slate leading-none md:leading-none`}>
          {solicitorName}
        </span>
      </div>
      <Button
        type="button"
        label="Change"
        colorVariant="secondary"
        variant="outlined"
        onClick={onReset}
        className="w-full md:w-auto"
      />
    </CalloutBox>
  );
};
